import React from 'react';
import Icon from '../../../components/AppIcon';

const SupportTypeCard = ({ type, isSelected, onSelect }) => {
  const typeConfig = {
    strategy: {
      icon: 'Target',
      title: 'Strategy Consultation',
      description: 'Comprehensive marketing strategy review and planning session',
      duration: '60 minutes',
      color: 'var(--color-primary)'
    },
    content: {
      icon: 'FileText',
      title: 'Content Planning',
      description: 'Social media content calendar and campaign planning',
      duration: '45 minutes',
      color: 'var(--color-accent)'
    },
    technical: {
      icon: 'Settings',
      title: 'Technical Support',
      description: 'Platform setup, asset management, and implementation guidance',
      duration: '30 minutes',
      color: 'var(--color-secondary)'
    },
    training: {
      icon: 'GraduationCap',
      title: 'Training Session',
      description: 'Best practices training and platform walkthrough',
      duration: '45 minutes',
      color: 'var(--color-warning)'
    }
  };

  const config = typeConfig?.[type];

  return (
    <button
      onClick={() => onSelect(type)}
      className={`w-full p-6 rounded-lg border-2 transition-all duration-250 text-left ${
        isSelected
          ? 'shadow-md'
          : 'border-border bg-card hover:shadow-sm'
      }`}
      style={isSelected ? {
        borderColor: 'var(--corvid-background-color, rgba(var(--bg, var(--color_17, 37, 99, 235)), var(--alpha-bg, 1)))',
        backgroundColor: 'var(--corvid-background-color, rgba(var(--bg, var(--color_17, 37, 99, 235)), var(--alpha-bg, 0.05)))'
      } : {}}
      aria-pressed={isSelected}
    >
      <div className="flex items-start gap-4">
        <div
          className="w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0"
          style={isSelected ? {
            backgroundColor: 'var(--corvid-background-color, rgba(var(--bg, var(--color_17, 37, 99, 235)), var(--alpha-bg, 0.1)))'
          } : { backgroundColor: 'var(--color-muted)' }}
        >
          <Icon name={config?.icon} size={24} color={isSelected ? 'black' : 'currentColor'} />
        </div>

        <div className="flex-1 min-w-0">
          <h3 className="text-lg font-semibold text-foreground mb-2">{config?.title}</h3>
          <p className="text-sm text-muted-foreground mb-3 line-clamp-2">{config?.description}</p>
          <div className="flex items-center gap-2">
            <Icon name="Clock" size={14} color="var(--color-muted-foreground)" />
            <span className="text-xs text-muted-foreground font-caption">{config?.duration}</span>
          </div>
        </div>

        {isSelected && (
          <div className="flex-shrink-0">
            <div className="w-6 h-6 rounded-full flex items-center justify-center" style={{ backgroundColor: 'var(--corvid-background-color, rgba(var(--bg, var(--color_17, 37, 99, 235)), var(--alpha-bg, 1)))' }}>
              <Icon name="Check" size={16} color="black" />
            </div>
          </div>
        )}
      </div>
    </button>
  );
};

export default SupportTypeCard;